import React , {useEffect} from "react";
import * as ReactDOM from "react-dom";
import { GetProfileImages } from "../../DocumentDetails/slice";
import {
  Grid,
  GridColumn as Column,
  GridNoRecords,
} from "@progress/kendo-react-grid";
import "@progress/kendo-theme-material/dist/all.css";
import { toODataString } from "@progress/kendo-data-query";
import { useDispatch, useSelector } from "react-redux";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import NewModal from "./NewModal";
import NewModalManager from "./NewModalManager";
import {
  areaOfActivity,
  ComponentType,
  EntityType,
  EntityTypeQuestion,
  RegistrationPortugeseStatus,
  RegistrationPortugeseStatus2,
  RegistrationStatus,
} from "../../../common/enum";
import i18next, { t } from "i18next";
import { useTranslation } from "react-i18next";
import {
  getEntitiesList,
  setAdminGridCountySelect,
  setAdminGridDistrictSelect,
  setAdminViewEntityDetail,
  setDrawerState,
  setEntitiesLimit,
  setEntitiesOffset,
  setSnackbarMessage,
  setSnackbarOpen,
  setSnackbarSeverity,
  setRejectPayload,
  setConfirmationDialog,
  setHeaderTitle,
  setAdminViewBranchEntityDetail,
  setBranchDrawerState,
  setConfirmationBranchDialog,
} from "../../AdminView/adminSlice";
import { DropdownFilterCell } from "../../Datagrid/ColumnMenu";
import { debounce } from "lodash";
import Tooltip from "@mui/material/Tooltip";
import DoneIcon from "@mui/icons-material/Done";
import ClearIcon from "@mui/icons-material/Clear";
import InfoIcon from "@mui/icons-material/Info";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import {
  Stack,
  Button,
  Typography,
  Box,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Avatar,
  useTheme,
} from "@mui/material";
import Drawer from "@mui/material/Drawer";
import Divider from "@mui/material/Divider";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { updateRegistrationDetail } from "../../OnBoarding/slice";
import { AddressData } from "../../../common/enum/addressData";
import ConfirmDialog from "../../../components/ConfirmDialog";
import { useSnackbar } from "notistack";
import Loader from "../../../components/Loader";
import { green } from "@mui/material/colors";
import {
  getChildEntitiesList,
  setBranchEntitiesLimit,
  setBranchEntitiesOffset,
} from "../../../redux/features/authSlice";
import { ExpandCircleDown } from "@mui/icons-material";
import { IntlProvider, load, LocalizationProvider, loadMessages } from '@progress/kendo-react-intl';
import esMessages from '../../Donations/DonationCard/tlklang.json';


loadMessages(esMessages, 'pt-PT');


const StatusCell = (props) => {
  const { translate } = useSelector((state) => state);

  const { t } = useTranslation();

  React.useEffect(() => {
    i18next.changeLanguage(translate);
  }, [translate]);

  return <td>{t(`${props.dataItem.status}`)}</td>;
};

const NameCell = (props) => {
  const { translate } = useSelector((state) => state);

  const { t } = useTranslation();

  React.useEffect(() => {
    i18next.changeLanguage(translate);
  }, [translate]);
  return <td>{props.dataItem.entity.entityName}</td>
  //return <td>{t(`${props.dataItem.addresses[0]?.addressTitle}`)}</td>;
};



const ViewEntityDetails = ({ t }) => {
  function toLocalISOString(inputDate) {
    const date = inputDate instanceof Date ? inputDate : new Date(inputDate);
  
    if (isNaN(date)) {
      throw new Error('Invalid date');
    }
  
    const offsetMs = date.getTimezoneOffset() * 60000;
    const adjustedDate = new Date(date.getTime() - offsetMs);
    return adjustedDate.toISOString().slice(0, -1);
  }
  const {
    adminDashboard: {
      entitiesList,
      entitiesCount,
      branchDrawerState,
      rejectPayload,
      entitiesLimit,
      entitiesOffset,
      confirmationBranchDialog,
      loading,
      headerTitle,
      adminViewBranchEntityDetail
    },
    auth: {
      branchEntitiesCount,
      branchEntitiesOffset,
      branchEntitiesLimit,
      branchEntities,
      branchEntitiesPage,
      profile: { entity },
    },
  } = useSelector((state) => state);
  const { enqueueSnackbar } = useSnackbar();
const theme = useTheme()
  const dispatch = useDispatch();

  const COVER_URL = "/static/illustrations/illustration_default_banner.jpg";
  const AVATAR_URL = "/static/illustrations/illustration_defaultavatar.png";

  const entityType =
    Object.keys(EntityType)[
      Object.values(EntityType).indexOf(
        adminViewBranchEntityDetail.entity.entityType
      )
    ];
  const areaActivity =
    Object.keys(areaOfActivity)[
      Object.values(areaOfActivity).indexOf(
        adminViewBranchEntityDetail.entity.areaOfActivity
      )
    ];

  const entityTypeQuestion = adminViewBranchEntityDetail.entity.isGroupEntity
    ? EntityTypeQuestion.groupUnitManangement
    : EntityTypeQuestion.store;

  const onApprove = React.useCallback(() => {
    const payload = {
      userId: adminViewBranchEntityDetail.entity.entityId,
      status: RegistrationStatus.active,
      registrationApprovedRejectedOn: toLocalISOString(new Date()),
      registrationApprovedRejectedBy: entity.entityId,
    };
    dispatch(updateRegistrationDetail(payload))
      .unwrap()
      .then((res) => {
        dispatch(setDrawerState(false));
        enqueueSnackbar({
          message: t("successfullyApproved"),
          variant: "success",
        });
        window.location.reload();
      })
      .catch((error) => {
        enqueueSnackbar({
          message: t("somethingWentWrong"),
          variant: "error",
        });
      });
  }, []);

  const onRejectedHandle2 = React.useCallback(() => {
    const payload = {
      userId: adminViewBranchEntityDetail.entity.entityId,
      status:
        adminViewBranchEntityDetail.status === RegistrationStatus.active
          ? RegistrationStatus.inActive
          : RegistrationStatus.rejected,
      registrationApprovedRejectedOn: toLocalISOString(new Date()),
      registrationApprovedRejectedBy: entity.entityId,
    };
    dispatch(
      setHeaderTitle(
        adminViewBranchEntityDetail.status === RegistrationStatus.active
          ? t("confirmationDeactivateContent")
          : t("confirmationRejectContent")
      )
    );
    dispatch(setRejectPayload(payload));
    //dispatch(setConfirmationBranchDialog(true));
    handleOpenModal(payload);
  }, []);

  const handleOpenModal = (payload) => {
    NewModalManager.openModal(
      <NewModal 
      open = {true}
      handleClose={() => NewModalManager.closeModal()}
      title = "De certeza que pretende desativar esta entidade? Se decidir proceder os utilizadores desta entidade também serão suspensos"
      onConfirm={onConfirm}
      payload = {payload}
      />
    );
  };
  
  const onConfirm = (motive , statusUpdate , dadosPayload) => {
    adminViewBranchEntityDetail.status == "ACTIVE"

    if(statusUpdate && dadosPayload){
      var updatedPayload = {
        ...dadosPayload, 
        observacoes: motive,
      };

      if(adminViewBranchEntityDetail.status == "ACTIVE"){
        updatedPayload.status = "IN_ACTIVE"
      }
      
    }
    dispatch(updateRegistrationDetail(updatedPayload))
      .unwrap()
      .then((res) => {
        let data = {
          limit: branchEntitiesLimit,
          offset: branchEntitiesOffset,
        };
        dispatch(getChildEntitiesList(data));
        dispatch(setBranchDrawerState(false));
        dispatch(setDrawerState(false));
        enqueueSnackbar({
          variant: "success",
          message: t("successfullyRejected"),
        });
        window.location.reload();
      })
      .catch((error) => {
        enqueueSnackbar({
          variant: "error",
          message: t("somethingWentWrong"),
        });
      });
  };

  const [entitybanneruri, setentitybanneruri] = React.useState("");
  const [profilepictureuri, setprofilepictureuri] = React.useState("");

  useEffect(() => {
  if(adminViewBranchEntityDetail.entity.bannerImage != "string" && adminViewBranchEntityDetail.entity.bannerImage != null ){
       dispatch(GetProfileImages(adminViewBranchEntityDetail.entity.bannerImage))
       .unwrap()
        .then((response) => {
          if(response.isActive != null){
            setentitybanneruri(response.isActive);
          }else{
            setentitybanneruri(COVER_URL);
          }
        })
    }

    if(adminViewBranchEntityDetail.entity.profilePicture != "string" && adminViewBranchEntityDetail.entity.profilePicture ){
       dispatch(GetProfileImages(adminViewBranchEntityDetail.entity.profilePicture))
       .unwrap()
        .then((response) => {
           if(response.isActive != null){
            setprofilepictureuri(response.isActive);
          }else{
            setprofilepictureuri(AVATAR_URL);
          }
        })
    }
	})

  return (
    <>
      <Box
        sx={{
          height: "110px",
          backgroundImage: `url(${
            adminViewBranchEntityDetail.entity.bannerImage === "string" ||
            adminViewBranchEntityDetail.entity.bannerImage === null
              ? COVER_URL
              : entitybanneruri
          }),url(${COVER_URL})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          position: "relative",
          marginBottom: "40px",
        }}
      >
        <Box
          sx={{
            // position: "absolute",
            width: "100%",
            height: "110px",
            bgcolor: "rgba(0, 0, 0, 0.54)",
            // display: "flex",
            // justifyContent: "flex-start",
          }}
        >
          <Avatar
            alt="Profile picture"
            src={
              adminViewBranchEntityDetail.entity.profilePicture === "string" ||
              adminViewBranchEntityDetail.entity.profilePicture === null
                ? AVATAR_URL
                : profilepictureuri
            }
            sx={{
              position: "absolute",
              backgroundColor: "green",
              margin: "0 30px",
              left: "0",
              right: "0",
              bottom: "0",
              borderRadius: "50%",
              width: "100px",
              height: "100px",
              transform: "translateY(50%)" /* additional 50% of own height */,
              boxShadow: "0 0 0 10px #fff",
              "& img": {
                height:
                adminViewBranchEntityDetail.entity.profilePicture === "string" ||
                adminViewBranchEntityDetail.entity.profilePicture === null
                    ? "100%"
                    : "100%",
                width:
                adminViewBranchEntityDetail.entity.profilePicture === "string" ||
                adminViewBranchEntityDetail.entity.profilePicture === null
                    ? "100%"
                    : "100%",
              },
            }}
          />
          <Typography
            variant="h6"
            sx={{
              position: "absolute",
              color: "white",
              left: "150px",
              right: "0",
              bottom: "20px",
              fontSize: "1.50rem!important",
              [theme.breakpoints.down("md")]:{
                fontSize: "1.2rem!important",
              }
            }}
          >
            {adminViewBranchEntityDetail.entity.entityName}
          </Typography>
        </Box>
      </Box>
      {(adminViewBranchEntityDetail.status === RegistrationStatus.inActive ||
        adminViewBranchEntityDetail.status === RegistrationStatus.rejected) && (
        <Box
          sx={{
            // width: 1,
            // border: `1px solid #EE9500`,
            backgroundColor: `#FFFBD4`,
            display: "flex",
            alignItems: "center",
            borderRadius: 1.5,
            p: 1.5,
            mt: 4,
            mx: 2,
          }}
        >
          <InfoIcon
            sx={{
              backgroundColor: `#EE9500`,
              color: "white",
              width: 32,
              height: 32,
              padding: 0.5,
              borderRadius: "10px",
            }}
          />
          <Typography variant="body2" fontWeight={600} mx={2}>
            {adminViewBranchEntityDetail.status === RegistrationStatus.inActive
              ? `${t("statusInActiveInfo")}`
              : `${t("statusRejectorInfo")}`}
          </Typography>
        </Box>
      )}
      <Box
        sx={{
          padding: 2,
        }}
      >
        <Accordion
          sx={{ border: "none", boxShadow: "none" }} className="testeacrd"
          defaultExpanded={true}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header2"
          >
            <Typography fontSize="26px" gutterBottom marginBottom="0px">
              <b className="boldNone" >{t("profileDetails")}</b>
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Paper
              variant="outlined"
              sx={{
                display: "flex",
                flexDirection: "column",
                p: 1,
              }}
            >
              <Divider />
              <Typography variant="subtitle">
                <b>{t("profileQuestion")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {t(`${entityType}`)}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("activityQuestion")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {t(`${areaActivity}`)}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("entityTypeQuestion")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {t(`${entityTypeQuestion}`)}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("NIF/NIC")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewBranchEntityDetail.entity.nic}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("name")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewBranchEntityDetail.addresses[0].addressTitle}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("id")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewBranchEntityDetail.entity.entityId}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("registrationEmail")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewBranchEntityDetail.email}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("status")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {t(`${adminViewBranchEntityDetail.status}`)}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("actionTakenOn")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewBranchEntityDetail.registrationApprovedRejectedOn}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("actionTakenBy")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewBranchEntityDetail.registrationApprovedRejectedBy}
              </Typography>
            </Paper>
          </AccordionDetails>
        </Accordion>
        <Divider />
        <Accordion sx={{ border: "none", boxShadow: "none" }}  className="testeacrd">
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header2"
          >
            <Typography fontSize="26px" gutterBottom  marginBottom="0px">
              <b className="boldNone">{t("primaryAddress")}</b>
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Paper
              variant="outlined"
              sx={{
                display: "flex",
                flexDirection: "column",
                p: 1,
                mt: 1,
              }}
            >
              <Divider />
              <Typography variant="subtitle">
                <b>{t("addressTitle")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewBranchEntityDetail.addresses[0].addressTitle}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("houseHold")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewBranchEntityDetail.addresses[0].addressLine}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("district")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewBranchEntityDetail.addresses[0].district}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("county")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewBranchEntityDetail.addresses[0].county}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("parshi")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewBranchEntityDetail.addresses[0].subDivision}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("locality")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewBranchEntityDetail.addresses[0].locality}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("postcard")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewBranchEntityDetail.addresses[0].postalCode}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("addressEmail")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewBranchEntityDetail.addresses[0].email}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("phone")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewBranchEntityDetail.addresses[0].phone}
              </Typography>
              <Divider />
            </Paper>
          </AccordionDetails>
        </Accordion>
        <Divider />
        <Accordion sx={{ border: "none", boxShadow: "none" }} className="testeacrd">
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header2"
          >
            <Typography fontSize="26px" gutterBottom marginBottom="0px">
              <b className="boldNone">{t("contactDetail")}</b>
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Paper
              variant="outlined"
              sx={{
                display: "flex",
                flexDirection: "column",
                p: 1,
                mt: 1,
              }}
            >
              <Typography variant="subtitle">
                <b>{t("contactName")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewBranchEntityDetail.contact[0].name}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("email")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewBranchEntityDetail.contact[0].email}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("designation")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewBranchEntityDetail.contact[0].designation}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("mobile")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewBranchEntityDetail.contact[0].mobile}
              </Typography>
            </Paper>
          </AccordionDetails>
        </Accordion>
        <Divider />
        <Accordion sx={{ border: "none", boxShadow: "none" }} className="testeacrd">
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header2"
          >
            <Typography fontSize="26px" gutterBottom marginBottom="0px">
              <b className="boldNone">{t("otherDetails")}</b>
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Paper
              variant="outlined"
              sx={{
                display: "flex",
                flexDirection: "column",
                p: 1,
                mt: 1,
              }}
            >
              <Typography variant="subtitle">
                <b>{t("totalDonations")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewBranchEntityDetail.totalNumberOfDonations}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("totalCollections")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewBranchEntityDetail.totalNumberOfCollections}
              </Typography>
            </Paper>
          </AccordionDetails>
        </Accordion>
        <Divider />
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
          }}
        >
          {/* {adminViewBranchEntityDetail.status !== RegistrationStatus.active && (
            <Button variant="contained" onClick={onApprove} sx={{ mr: 1,borderRadius:"4px" }}>
             {adminViewBranchEntityDetail.status === "ACTIVE"
                ?t("approved")
                :t("activate")}
            </Button>
          )} */}
          {adminViewBranchEntityDetail.status != "ACTIVE" && adminViewBranchEntityDetail.status != "INVITED" &&(
            
            <Button
              variant="contained"
              onClick={onApprove}
              
              sx={{ mr: 1, borderRadius: "4px" , marginTop:"8px"}}
            >
              {adminViewBranchEntityDetail.status === "ACTIVE"
                ?t("approved")
                :t("activate")}
            </Button>
          )}
          {adminViewBranchEntityDetail.status == "ACTIVE" && adminViewBranchEntityDetail.status != "INVITED" &&(
            <Button
              variant="contained"
              onClick={onRejectedHandle2}
              id="rejectButton"
              sx={{
                background: "#FFEEEE",
                color: "#FF0000",
                padding: "8px 22px",
                borderRadius: "4px",
                marginTop:"8px",
                "&:hover": { background: "#FF0000", color: "#FFEEEE" },
              }}
            >
              {adminViewBranchEntityDetail.status === 'IN_ACTIVE '
                ? t("rejected")
                : t("deactivate")}
                
            </Button>
          )}
        </Box>
      </Box>
    </>
  );
};

const ActionCell = (props) => {
  const dispatch = useDispatch();

  const {
    auth: { profile: entity },
  } = useSelector((state) => state);
  const { enqueueSnackbar } = useSnackbar();

  const onViewClick = () => {
    dispatch(setBranchDrawerState(true));
    dispatch(setAdminViewBranchEntityDetail(props.dataItem));
  };

  const onApproved = React.useCallback(() => {
    const payload = {
      userId: props.dataItem.entity.entityId,
      status: RegistrationStatus.active,
      registrationApprovedRejectedOn: toLocalISOString(new Date()),
      registrationApprovedRejectedBy: entity.entityId,
    };
    dispatch(updateRegistrationDetail(payload))
      .unwrap()
      .then((res) => {
        enqueueSnackbar({
          variant: "success",
          message: t("successfullyApproved"),
        });
      })
      .catch((error) => {
        enqueueSnackbar({
          variant: "error",
          message: t("somethingWentWrong"),
        });
      });
  }, []);



  return (
    <td>
      <Stack direction={"row"} mt="10px" alignItems="center" spacing={1}>
        <Tooltip title={t("viewDetails")} arrow>
          <Button sx={{ p: 0, minWidth: 0,borderRadius:"4px" }} onClick={onViewClick}>
            <RemoveRedEyeIcon fontSize="small" />
          </Button>
        </Tooltip>
        {/* {props.dataItem.status !== RegistrationStatus.active && (
          <Tooltip title={t("approved")} arrow>
            <Button sx={{ p: 0, minWidth: 0,padding:2}} onClick={onApproved}>
              <DoneIcon fontSize="small" />
            </Button>
          </Tooltip>
        )}
        {(props.dataItem.status !== RegistrationStatus.rejected ||
          props.dataItem.status !== RegistrationStatus.revoked ||
          props.dataItem.status !== RegistrationStatus.inActive) && (
          <Tooltip
            title={
              props.dataItem.status === RegistrationStatus.active
                ? t("deactivate")
                : t("rejected")
            }
            arrow
          >
            <Button sx={{ p: 0, minWidth: 0,padding :props.dataItem.status === RegistrationStatus.active ? 1.5:0 }} onClick={onRejectedHandle}>
              <ClearIcon fontSize="small" />
            </Button>
          </Tooltip>
        )} */}
      </Stack>
    </td>
  );
};

const StatusFilterCell = (props) => {
  return (
    <DropdownFilterCell
      {...props}
      data={Object.values(RegistrationPortugeseStatus2)}
      defaultItem={"Selecione o Estado"}
    />
  );
};



const Branches = ({ entityId, t }) => {
  const theme = useTheme();
  const {
    adminDashboard: {
      entitiesList,
      entitiesCount,
      branchDrawerState,
      rejectPayload,
      entitiesLimit,
      entitiesOffset,
      confirmationBranchDialog,
      loading,
      headerTitle,
    },
    auth: {
      branchEntitiesCount,
      branchEntitiesOffset,
      branchEntitiesLimit,
      branchEntities,
      branchEntitiesPage,
    },
  } = useSelector((state) => state);

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const handleClose = React.useCallback(() => {
    dispatch(setConfirmationBranchDialog(false));
  }, [dispatch]);

  const onConfirm = () => {
    dispatch(updateRegistrationDetail(rejectPayload))
      .unwrap()
      .then((res) => {
        let data = {
          limit: branchEntitiesLimit,
          offset: branchEntitiesOffset,
        };
        dispatch(getChildEntitiesList(data));
        dispatch(setConfirmationBranchDialog(false));
        dispatch(setBranchDrawerState(false));
        enqueueSnackbar({
          variant: "success",
          message:
            rejectPayload.status === RegistrationStatus.active
              ? t("successfullyDeactivated")
              : t("successfullyRejected"),
        });
      })
      .catch((error) => {
        enqueueSnackbar({
          variant: "error",
          message: t("somethingWentWrong"),
        });
      });
  };

  const filterOperators = {
    text: [
      {
        text: "grid.filterContainsOperator",
        operator: "contains",
      },
    ],
    numeric: [
      {
        text: "grid.filterEqOperator",
        operator: "eq",
      },
    ],
    date: [
      {
        text: "grid.filterEqOperator",
        operator: "eq",
      },
    ],
    boolean: [
      {
        text: "grid.filterEqOperator",
        operator: "eq",
      },
    ],
  };

  const timer = React.useRef(null);
  const [dataState, setDataState] = React.useState({
    take: 20,
    skip: 0,
  });

  React.useEffect(() => {
    const data = {
      entityId: entityId,
      limit: dataState.take + dataState.skip,
      offset: dataState.skip,
    };
    dispatch(getChildEntitiesList(data));
  }, [entityId]);

  const debouncedApiCall = debounce(async (value) => {
    const limit = value.skip + value.take;
    const offset = value.skip;
    let data = {
      limit: limit,
      offset: offset,
    };
    if (value.filter !== undefined) {
      value?.filter.filters.map((item) => {
        switch (item.field) {
          //   case "district":
          //     data["district"] = item.value;
          //     dispatch(setAdminGridDistrictSelect(item.value));
          //     break;
          //   case "county":
          //     data["county"] = item.value;
          //     break;
          //   case "subDivision":
          //     data["subDivison"] = item.value;
          //     break;
          //   case "entity.entityName":
          //     data["entityName"] = item.value;
          //     break;
          case "status":
            data["status"] = Object.keys(RegistrationPortugeseStatus2).find(
              (key) => RegistrationPortugeseStatus2[key] === item.value
            );
            break;
        }
      });
    } else {
      dispatch(setAdminGridDistrictSelect(""));
      dispatch(setAdminGridCountySelect(""));
    }
    dispatch(getChildEntitiesList(data));
    dispatch(setBranchEntitiesLimit(limit));
    dispatch(setBranchEntitiesOffset(offset));
  }, 1000);

  const dataStateChange = (e) => {
    const value = e.dataState;
    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      debouncedApiCall(value);
    }, 1000);
    setDataState(e.dataState);
  };

  return (
    <React.Fragment>
      {loading && <Loader phrase={"adminEntitiesLoadingPhrase"} t={t} />}
      {!loading && (
        <>
         <LocalizationProvider language="pt-PT" >
         <IntlProvider locale="pt">
         <Grid
          data={branchEntities}
          style={{ height: "70vh" }}
          resizable={true}
          // skip={page.skip}
          // take={page.take}
          filterOperators={filterOperators}
          total={branchEntitiesCount}
          pageable={true}
          {...dataState}
          // onPageChange={pageChange}
          onDataStateChange={dataStateChange}
          filterable={true}
          // groupable={true}
        >
          <GridNoRecords>{t("noRecordAvailable")}</GridNoRecords>
          <Column
            field="name"
            title={t("name")}
            cell={NameCell}
            // filter={"text"}
            filterable={false}
          />
          <Column
            field="status"
            title={t("status")}
            //filterCell={StatusFilterCell}
            cell={StatusCell}
            filterable={false}
          />
          <Column
            field=""
            title={`Ações`}
            cell={ActionCell}
            filterable={false}
          />
        </Grid>
          </IntlProvider>
          </LocalizationProvider>
        </>
        
      )}
      {/* <EntitiesLoader dataState={dataState} /> */}
      <Drawer
        anchor={"right"}
        open={branchDrawerState}
        PaperProps={{
          sx: {
            width: "50%",
            [theme.breakpoints.down("md")]: {
              width: 1,
            },
          },
        }}
        onClose={() => {
          dispatch(setBranchDrawerState(false));
        }}
      >
        <Button
          sx={{
            position: "fixed",
            right: "51%",
            top: 10,
            zIndex: 1,
            minWidth: 0,
            borderRadius: "4px",
            padding: "4px",
            backgroundColor: "#ffc3c3",
            "&:hover": {
              backgroundColor: "#ffc3c3",
            },
            "@media (max-width:900px)": {
              right: "1%",
            },
          }}
          onClick={() => {
            dispatch(setBranchDrawerState(false));
          }}
        >
          <CloseOutlinedIcon color="error" />
        </Button>
        <ViewEntityDetails t={t} />
      </Drawer>
      <ConfirmDialog
        open={confirmationBranchDialog}
        handleClose={handleClose}
        title={t("")}
        content={headerTitle}
        onConfirm={onConfirm}
        cancelButtonTitle={t("cancel")}
        confirmButtonTitle={t("confirm")}
      />
    </React.Fragment>
  );
};

export default Branches;
